import React from 'react'
import Pricing from './components/PricingSection'
import PricingTable from './components/PricingTable'

const Index = () => {
  return (
    <div>
        <Pricing/>
        <PricingTable/>
    </div>
  )
}

export default Index
